/* eslint-disable */
import CircularProgress from '@mui/material/CircularProgress'
import PropTypes from 'prop-types'

const LoadingSpinner = ({
	color,
	size,
	thickness,
	sx,
	centered
}) => {
	return (
		centered ? (
			<div style={{
				width: '100vw',
				display: 'flex',
				justifyContent: 'center',
				height: '75vh',
				alignItems: 'center',
			}}
			>
				<CircularProgress 
					size={size}
					thickness={thickness}
					sx={{color: {color}, ...sx}}
					data-testid='centeredSpinner'
				/>
			</div>
		) : (
			<CircularProgress 
				size={size}
				thickness={thickness}
				sx={{color: {color}, ...sx}}
				data-testid='unformattedSpinner'
			/>
		)
	);
};


LoadingSpinner.propTypes = {
	color: PropTypes.string,
	size: PropTypes.number,
	thickness: PropTypes.number,
	centered: PropTypes.bool,
}

LoadingSpinner.defaultProps = {
	color: '#C1BBB3',
	size: 48,
	thickness: 3,
	centered: true,
}

// allowed sizes:
// 48px size with 3px thickness
// 32px size with 2px thickness
// 16px size with 1px thickness

export default LoadingSpinner;